import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Info from "../Components/Info";
import About from "../Components/About";
import Reviews from "../Components/Reviews";
import BookAppointment from "../Components/BookAppointment";
import Footer from "../Components/Footer";

function Home() {
  return (
    <div className="home-section">
      <Navbar />
      <BookAppointment />
      <Info />
      <About />
      <Hero />
      <Reviews />
      <Footer />
    </div>
  );
}

export default Home;
